import { defineMessages } from 'react-intl-next';

export default defineMessages({
    topicsSectionLabel: {
        defaultMessage: 'Topics',
        description: 'Label for the Topics section on the Help center',
        id: 'cv.help-center.topics.label',
    },
    allPortalsHidden: {
        defaultMessage: 'There’s no help content available here',
        description: 'Bold message when customer do not see any portals on help center landing page',
        id: 'cv.premium-help-center.empty.page.title',
    },
    allPortalsHiddenAction: {
        defaultMessage: 'Try using the search bar to find help articles or request forms. ',
        description: 'Description to guide customer to contact support when not seeing any portals',
        id: 'cv.premium-help-center.empty.page.description',
    },
});
